import { RouteType } from "types/RouteType";
import RegistryImagesStore from "./RegistryImagesStore";

const registryImagesRoute: RouteType[] = [
  {
    name: "Registry Images",
    path: "/infrastructure/registry-images",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Registry Images",
        enableRefreshButton: true,
        component: () => import("./RegistryImages.Header"),
      },
      body: {
        component: () => import("./RegistryImages.Body"),
        grayBackground: true,
      },
    },
    group: "Infrastructure",
    searchAliases: ["acr images", "image tags", "containers"],
    // Read-only catalog of an ACR's repositories + tags. Staff (viewer+); the
    // API enforces the read gate on registry-repositories / registry-tags.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.registryImagesStore as RegistryImagesStore;
      void store?.initialize();
    },
  },
];

export default registryImagesRoute;
